import React from 'react';
import { useCurrentEditor } from '@tiptap/react';

import type { SelectedToken, SuggestionOption } from '~/components/core/Editor/types';
import HierarchicalSearchablePopover from '~/components/core/Molecules/HierarchicalSearchablePopover/HierarchicalSearchablePopover';
import DropDownIcon from '~/components/icons/editor/DropDownIcon';
import SuggestionIcon from '~/components/icons/editor/SuggestionIcon';
import usePopoverState from '~/components/ui/atoms/Popover/usePopoverState';

import ToolbarButton from '../ToolbarButton';

interface SuggestionComponentProps {
  buttonClassName?: string;
  options: SuggestionOption[];
}

const SuggestionComponent: React.FC<SuggestionComponentProps> = ({ buttonClassName, options }) => {
  const { triggerProps, popoverProps, close } = usePopoverState();
  const { editor } = useCurrentEditor();

  // This is a workaround to trigger the mention func.
  // Creating an Extension Extend works but throws console errors
  const triggerMentionInEditor = ({ id, label, groupPath }: SelectedToken) => {
    editor?.extensionManager.extensions
      .find(({ name }) => name === 'mention')
      ?.options.suggestion.command({
        editor,
        range: { from: editor.state.selection.ranges[0].$from.pos, to: editor.state.selection.ranges[0].$from.pos },
        props: { label, id, groupPath },
      });
    return editor;
  };

  const selectItem = (token: SelectedToken) => {
    triggerMentionInEditor(token);
    close();
  };

  const disabled = !editor?.isEditable;

  return (
    <>
      <ToolbarButton disabled={disabled} className={buttonClassName} aria-label="Insert token" {...triggerProps}>
        <div className="inline-flex items-center justify-between">
          <SuggestionIcon />
          <DropDownIcon className="ml-4 min-w-fit" size={12} />
        </div>
      </ToolbarButton>
      <HierarchicalSearchablePopover {...popoverProps} label="Insert token" options={options} onSelect={selectItem} />
    </>
  );
};

export default SuggestionComponent;
